import { BehaviorSubject, Observable } from "rxjs";

declare const document: any;

export interface ScriptStatus {
  loaded: boolean;
  loading: boolean;
  error: boolean;
}

export class ScriptService {
  private status: Map<string, BehaviorSubject<ScriptStatus>> = new Map<
    string,
    BehaviorSubject<ScriptStatus>
  >();

  public load(scriptSrc: string): Observable<ScriptStatus> {
    const subject = this.getOrCreateSubject(scriptSrc);
    this.loadScript(scriptSrc, subject);
    return subject.asObservable();
  }

  public unload(scriptSrc: string) {
    const col = document.getElementsByTagName("script");
    for (const script of col) {
      if (script.src === scriptSrc) {
        document.body.removeChild(script);
        break;
      }
    }
  }

  private loadScript(src: string, statusSubject: BehaviorSubject<ScriptStatus>) {
    if (this.isScriptLoaded(src)) {
      statusSubject.next({
        error: false,
        loaded: true,
        loading: false,
      });
    } else {
      if (!statusSubject.getValue().loaded && !statusSubject.getValue().loading) {
        statusSubject.next({
          ...statusSubject.getValue(),
          loading: true,
        });
      }
      this.createAndLoad(src, statusSubject);
    }
  }

  private createAndLoad(src: string, subject: BehaviorSubject<ScriptStatus>) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    if (script.readyState) {
      // IE
      script.onreadystatechange = () => {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          subject.next({
            error: false,
            loaded: true,
            loading: false,
          });
        }
      };
    } else {
      // Others
      script.onload = () => {
        subject.next({
          error: false,
          loaded: true,
          loading: false,
        });
        subject.complete();
      };
    }
    script.onerror = () => {
      subject.next({
        error: true,
        loaded: false,
        loading: false,
      });
      subject.complete();
    };
    document.body.appendChild(script);
  }

  private getOrCreateSubject(scriptSrc: string): BehaviorSubject<ScriptStatus> {
    const subject = this.getSubject(scriptSrc);
    if (!subject) {
      return this.createSubject(scriptSrc);
    }
    return subject;
  }

  private createSubject(scriptSrc: string): BehaviorSubject<ScriptStatus> {
    const subject = new BehaviorSubject<ScriptStatus>({
      error: false,
      loaded: false,
      loading: false,
    });
    this.status.set(scriptSrc, subject);
    return subject;
  }

  // private setSubject(scriptSrc: string, subject: BehaviorSubject<ScriptStatus>) {
  //   this.status.set(scriptSrc, subject);
  // }

  private getSubject(scriptSrc: string): BehaviorSubject<ScriptStatus> | undefined {
    return this.status.get(scriptSrc);
  }

  private isScriptLoaded(scriptSrc: string) {
    return this.status.get(scriptSrc)!.getValue().loaded;
  }
}

export default new ScriptService();
